"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHECKBOX_STATES = void 0;
const CHECKBOX_STATES = exports.CHECKBOX_STATES = ['unselected', 'selected', 'indeterminate'];